import { Button, FormControlLabel, Grid, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";

const PageToolbar = styled(Grid)(() => ({
    marginBottom: "20px",
    marginTop: "20px",
}));

const LeftIcon = styled(Grid)(() => ({
    marginLeft: "25px",
}));

const InactiveText = styled("div")(() => ({
    fontSize: "14px",
    paddingRight: "25px",
}));

const AdminToolbar = (props) => {
    const { handleInputChange, handleSaveAccountUpdates, history, userAccount } = props;

    const handleCancel = () => {
        history.push("/admin/users");
    };
    return (
        <PageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">Edit User Account</h2>
            </Grid>
            <Grid item>
                <Grid container alignItems="center" spacing={0}>
                    <Grid item>
                        {get(userAccount, "activeFlg", null) === false &&
                        get(userAccount, "inactiveDate", null) != null ? (
                            <InactiveText>Inactivated On: {get(userAccount, "inactiveDate", null)}</InactiveText>
                        ) : (
                            ""
                        )}
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={userAccount.activeFlg ? true : false}
                                    onChange={(e) => handleInputChange("userAccount.activeFlg", e.target.checked)}
                                    color="primary"
                                    disabled={false}
                                />
                            }
                            label="Active"
                        />
                    </Grid>
                    <LeftIcon item>
                        <Button variant="outlined" color="primary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </LeftIcon>
                    <Grid item>
                        <Button color="primary" variant="contained" onClick={handleSaveAccountUpdates}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </PageToolbar>
    );
};

export default AdminToolbar;
